export default __webpack_public_path__ + "static/media/Kaspy-BG.9d59340d.webp";